// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import 'vue-tel-input/dist/vue-tel-input.css';
import VeeValidate from 'vee-validate';
import ImageUploader from 'vue-image-upload-resize';
import ImageCropper from 'vue-cropper';
import ReadMore from 'vue-read-more';
import VuePlyr from 'vue-plyr';
import VueCountdownTimer from 'vuejs-countdown-timer/dist/vuejs-countdown-timer.min';
import ToggleButton from 'vue-js-toggle-button';
import vueCountryRegionSelect from 'vue-country-region-select';
import ElementUI from 'element-ui';
import EleUploadVideo from 'vue-ele-upload-video';
import Notifications from 'vue-notification';
import Viewer from 'v-viewer';
import LinkPrevue from 'link-prevue';
import _ from 'lodash';
import Embed from 'v-video-embed';
import InfiniteLoading from 'vue-infinite-loading';
import interceptor from './utils/interceptor';
import 'vue-plyr/dist/vue-plyr.css';
import 'element-ui/lib/theme-chalk/index.css';
import 'viewerjs/dist/viewer.css';
import 'vueperslides/dist/vueperslides.css';

import store from './store';
import App from './App.vue';
import router from './router';
import BaseButton from './UI/BaseButton.vue';

import formatDate from './utils/formatDate';
import VueGtag from 'vue-gtag'


Vue.use(ToggleButton);
Vue.use(ReadMore);
Vue.use(ImageUploader);
Vue.use(ImageCropper);
Vue.use(VuePlyr);
Vue.use(Embed);
Vue.use(LinkPrevue);
Vue.use(BootstrapVue);
Vue.use(VeeValidate);
Vue.use(vueCountryRegionSelect);
Vue.use(VueCountdownTimer);
Vue.use(ElementUI);
Vue.use(InfiniteLoading);
Vue.use(Notifications);
Vue.use(EleUploadVideo);
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999,
  },
});

Vue.use(VueGtag,  {
  config: {
    id: 'G-WBJDNMHVR8'
  }
}, router);


Vue.component('base-button', BaseButton);


Object.defineProperty(Vue.prototype, '$lodash', { value: _ });
Object.defineProperty(Vue.prototype, '$formatDate', { value: formatDate });
Vue.config.productionTip = false;

/**
 * Init Axios interceptors in order to init "loader" and "alert" system
 */
interceptor.initAxiosInterceptors();


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
});
